/** Knowledge gaps screen (/w/:ws/gaps). */
export const gaps = {
  title: "Knowledge gaps",
  subtitle: "Questions the assistant couldn't answer well, grouped by meaning. Answer once and every similar question is covered.",
  agentFilter: "Agent",
  export: "Export",
  exported: "Gap report exported · {{file}}",
  uploadDocument: "Upload document",
  uploadNewer: "Upload newer version",
  openOutdated: "Open outdated source",
  stats: {
    open: "Open gaps",
    questionsAffected_one: "{{count}} question affected",
    questionsAffected_other: "{{count}} questions affected",
    resolvedMonth: "Resolved this month",
    vsLastMonth: "{{delta}} vs last month",
    coverage: "Answer coverage",
    coverageNone: "No answers yet",
    topCategory: "Top gap category",
    topCategoryNone: "None yet",
    topCategoryHint: "Most asked among open gaps",
  },
  tabs: {
    label: "Gap views",
    unanswered: "Unanswered",
    lowConfidence: "Low confidence",
    negative: "Negative feedback",
    resolved: "Resolved",
  },
  search: "Search questions…",
  sort: {
    label: "Sort",
    most_asked: "Most asked",
    most_recent: "Most recent",
    oldest: "Oldest first",
  },
  columns: {
    cluster: "Question cluster",
    asked: "Asked",
    reason: "Reason",
    actions: "Actions",
  },
  selectAll: "Select all",
  selectRow: "Select {{label}}",
  bulk: {
    selected_one: "{{count}} selected",
    selected_other: "{{count}} selected",
    assignTo: "Assign to",
    ignore: "Ignore",
    clear: "Clear selection",
    assigned_one: "{{count}} gap assigned to {{name}}",
    assigned_other: "{{count}} gaps assigned to {{name}}",
    ignored_one: "{{count}} cluster ignored",
    ignored_other: "{{count}} clusters ignored",
  },
  reason: {
    no_source: "No source found",
    outdated: "Outdated source",
    low_confidence: "Low confidence",
    thumbs_down: "Thumbs down",
    resolved: "Resolved",
  },
  asks_one: "ask",
  asks_other: "asks",
  trendLabel: "Asks per day, last 7 days",
  moreQuestions: "+{{count}} more",
  firstLast: "First {{first}} · Last {{last}}",
  avgConfidence: "Avg confidence {{value}}",
  feedbackQuote: "Visitor feedback",
  writeAnswer: "Write answer",
  more: "More actions for {{label}}",
  assignHeading: "Assign to",
  assignedTo: "Assigned to {{name}}",
  assigned: "Assigned to {{name}} · they'll get an email",
  unassign: "Unassign",
  unassigned: "Assignment removed",
  ignoreMenu: "Ignore…",
  resolvedBy: "Resolved {{date}} · Q&A source",
  resolvedNoSource: "Resolved {{date}}",
  viewSource: "View source",
  showingResolved: "Showing {{shown}} resolved gaps",
  empty: {
    openTitle: "No gaps in this view",
    openBody: "The assistant is answering these questions well. New gaps appear here as visitors ask.",
    searchTitle: "No matching questions",
    searchBody: "Try another search or clear it to see every open gap.",
    clearSearch: "Clear search",
    resolvedTitle: "Nothing resolved yet",
    resolvedBody: "Gaps you answer or cover with a document move here.",
  },
  loadError: "Knowledge gaps couldn't load.",
  statsError: "Stats couldn't load.",
  footnote: "Questions are grouped automatically using semantic similarity (English, Filipino and Taglish phrasings are matched together). A gap closes when the assistant answers the cluster with ≥ 80% confidence.",
  sheet: {
    eyebrow: "Write answer",
    questions: "Questions in this cluster",
    viewChat: "Open conversation",
    answer: "Answer",
    answerPlaceholder: "Write the official answer. The assistant will rephrase it naturally and reply in the visitor's language.",
    answerTip: "Tip: include amounts, dates and who to contact. Taglish questions get Taglish answers automatically.",
    answerRequired: "Write or suggest an answer first",
    suggest: "Suggest with AI",
    suggested_one: "Draft based on {{count}} source. Please verify details.",
    suggested_other: "Draft based on {{count}} sources. Please verify details.",
    noSuggestion: "No source covers this yet — write the answer yourself.",
    access: "Who can see this answer",
    expires: "Expires",
    expiry: {
      never: "Never",
      days30: "In 30 days",
      days90: "In 90 days",
      custom: "Custom date…",
    },
    customDate: "Expiry date",
    customDateRequired: "Pick a future date",
    agents: "Agents that use this answer",
    agentsRequired: "Choose at least one agent",
    uploadInstead: "Upload a document instead",
    save: "Save as Q&A source",
    saved: "Saved as Q&A source · {{audience}} · now live",
    loadError: "This cluster couldn't load.",
  },
  ignore: {
    title: "Ignore this gap?",
    body: "Ignored clusters stop appearing here. The assistant keeps using its fallback reply for these questions.",
    reasonLabel: "Reason",
    out_of_scope: "Out of scope for this workspace",
    spam: "Spam / test messages",
    always_staff: "Should always go to staff (sensitive)",
    other: "Other",
    confirm: "Ignore cluster",
    done: "Cluster ignored",
  },
};
